import http from 'plugins/axios';

export default {
  getCoinList(data) {
    return http.post({
      url: '/la/admin/voteCoin/list',
      data
    });
  },
  createCoin(data) {
    return http.post({
      url: '/la/admin/voteCoin/create',
      data
    });
  }
};
